export default __webpack_public_path__ + "static/media/logo.c67410ce.png";